import { Attr, Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"

export enum PhysicalDetailTypeId {
  BuildingEnvelopeInformation = 2,
  EquipmentInformation = 3,
  SimulatorInformationV3 = 4,
}

@Model()
export class PhysicalDetail extends ApplicationRecord {
  public static readonly jsonapiType = "physical_details"

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Attr() public details!: Record<string, any>

  @Attr() public readonly subjectType!: "Site"

  @Attr() public readonly physicalDetailType!:
    | "building_envelope_information"
    | "equipment_information"
    | "simulator_information_v3"

  @Attr() public readonly physicalDetailTypeId!: PhysicalDetailTypeId

  @Attr() public readonly subjectId!: number // site id
}
